export enum Routes {
  CommunityCreator = '/community-wizard',
  EventWizard = '/events/wizard',
  MyCommunity = '/my-community',
  MyEvents = '/my-events',
  MyEventsUpcoming = '/upcoming',
  MyEventsPast = '/past',
  VideoCall = '/video-call',
  Backstage = '/backstage',
  WaitingRoom = '/waiting-room',
  Broadcast = '/broadcast',
}

export enum AppRoutes {
  CommunityCreator = '/community-wizard',
  CommunitySettings = '/community-settings',
  EventBackstage = '/event-room/:id/backstage',
  EventBroadcast = '/event-room/:id/broadcast',
  EventVideoCall = '/event-room/:id/video-call',
  EventWaitingRoom = '/event-room/:id/waiting-room',
  /** @deprecated use **EventDetails** */
  EventDetails_old = '/event-details/:id',
  EventDetails = '/my-events/details/:id',
  EventEnd = '/event-end/:id',
  EventPublic = '/event-public/:id',
  EventAddToCalendar = '/event-public/:id/calendar',
  EventRoom = '/event-room/:id',
  EventCallFeedback = '/event-room/:id/call-feedback',
  EventReport = '/event-details/:id/report',
  PublicEventReport = '/public/event/:id/report',
  PublicReport = '/report-public/:id',
  JoinEvent = '/event-details/:id/join',
  EventRoomSpeaker = '/event-room-speaker/:id/:token',
  EventWizard = '/events/wizard/:id?',
  InsightsReports = '/insights-reports',
  InsightsReportsEvents = '/events',
  InsightsReportsEventsList = '/insights-reports/events',
  InsightsReportsWizard = '/insights-reports/wizard',
  InsightsReportsWizardEvents = '/insights-reports/wizard/events',
  InsightsReportsEventById = '/insights-reports/events/:id',
  InsightsReportsNatalie = '/insights-reports/natalie',
  NatalieReport = '/insights-reports/natalie/:id',
  PublicNatalieReport = '/report-public/natalie/:id',

  MyCommunity = '/my-community',
  MyEvents = '/my-events',
  MyEventsUpcoming = '/my-events/upcoming',

  /** @deprecated use **Account** */
  MyProfile = '/user-profile',
  CommunityProfile = '/community-profile',
  Organization = '/org',
  JoinOrganization = '/org/:slug/:organizationId/join',
  RegisterToCommunity = '/invitation/:communityId',
  Settings = '/settings',
  SettingsBranding = '/settings/community-settings/branding',
  SettingsTags = '/settings/community-settings/tags',
  SettingsAuthentication = '/settings/community-settings/authentication',
  Account = '/account',
  // TODO Refactor AppRoute to constant and merge with modules routes
  Natters = '/natters',
  Natalie = '/natalie',
  TechCheck = '/tech-check',
  HealthCheck = '/health-check',
  CustomLogin = '/login/:slug?',
  Login = '/login',
  Otp = '/otp',
  MagicLinkCheckYourInbox = '/magic-link/check-your-inbox',
  MagicLinkLinkExpired = '/magic-link/link-expired',
  MagicLinkLinkInvalid = '/magic-link/link-invalid',
  TellUsAboutYourself = '/tell-us-about-yourself',
}

export const PublicRoutes = [
  AppRoutes.EventPublic,
  AppRoutes.PublicEventReport,
  AppRoutes.TechCheck,
  AppRoutes.HealthCheck,
  AppRoutes.CustomLogin,
];

export const MagicLinkRoutes = [
  AppRoutes.MagicLinkCheckYourInbox,
  AppRoutes.MagicLinkLinkExpired,
  AppRoutes.MagicLinkLinkInvalid,
  // Intercom-hide only (consumed solely by INTERCOM_HIDDEN_ROUTES) — NOT an auth allow-list.
  AppRoutes.Otp,
];

// Routes where Intercom widget should be hidden (core app)
export const INTERCOM_HIDDEN_ROUTES: readonly string[] = [
  // Live event routes
  AppRoutes.EventRoom,
  AppRoutes.EventBackstage,
  AppRoutes.EventBroadcast,
  AppRoutes.EventVideoCall,
  AppRoutes.EventWaitingRoom,
  AppRoutes.EventCallFeedback,
  AppRoutes.EventEnd,
  AppRoutes.JoinEvent,
  // Public routes
  ...PublicRoutes,
  ...MagicLinkRoutes,
];

// Routes where Intercom should be shown to anonymous (unauthenticated) users (core app)
export const INTERCOM_PUBLIC_ROUTES: readonly string[] = [
  AppRoutes.EventPublic,
  AppRoutes.CustomLogin,
  AppRoutes.Login,
];

// URL pattern to Intercom article ID mapping
export const INTERCOM_ARTICLE_MAP: Record<string, string> = {
  [AppRoutes.InsightsReports]: '12107909',
  [AppRoutes.InsightsReportsEventsList]: '12107909',
  [AppRoutes.EventReport]: '12107909',
  [AppRoutes.MyCommunity]: '10490386',
  [AppRoutes.SettingsBranding]: '10490393',
  [AppRoutes.SettingsTags]: '10490393',
  [AppRoutes.SettingsAuthentication]: '10490485',
};

export type EventRouteParams = {
  id?: string;
  hash?: string;
  register?: string;
};

export type WithRedirectUrl<T extends Record<string, unknown> = {}> = {
  redirectUrl: string;
} & T;

export type WithCode<T extends Record<string, unknown> = {}> = {
  code: string;
} & T;

export type InsightsReportRouteParams = {
  id: string;
};
